export default __webpack_public_path__ + "1ffd937ae410b6bccc4e547003308ebf.png";